import { render, staticRenderFns } from "./RatingScaleSetGrid.vue?vue&type=template&id=366013ee"
import script from "./RatingScaleSetGrid.vue?vue&type=script&lang=js"
export * from "./RatingScaleSetGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports